(() => {
  const groups = '.product-grid, .mg-products, .resource-list';
  let pending = false;
  const widths = new WeakMap();
  const observer = new ResizeObserver(entries => {
    if (entries.some(({target, contentRect}) => {
      const width = Math.round(contentRect.width);
      if (widths.get(target) === width) return false;
      widths.set(target, width);
      return true;
    })) schedule();
  });
  function equalize(elements) {
    elements.forEach(el => el.style.removeProperty('min-height'));
    const height = Math.ceil(Math.max(0, ...elements.map(el => el.getBoundingClientRect().height)));
    elements.forEach(el => el.style.minHeight = height + 'px');
  }
  function align() {
    pending = false;
    document.querySelectorAll(groups).forEach(group => {
      observer.observe(group);
      const cards = [...group.querySelectorAll('product-card, .mg-product')]
        .filter(card => card.closest(groups) === group && card.getBoundingClientRect().width > 0);
      const lists = cards.map(card => card.querySelector('.mg-usps--card')).filter(Boolean);
      if (!lists.length) return;
      // Recalculate natural sizes first, including when switching to a narrower grid.
      lists.forEach(list => {
        list.style.removeProperty('margin-top');
        [...list.children].forEach(row => row.style.removeProperty('min-height'));
      });
      equalize(cards.map(card => (card.querySelector('[ref="productTitleLink"] .text-block') || card.querySelector('h3'))).filter(Boolean));
      equalize(cards.map(card => card.querySelector('product-price, .mg-price')).filter(Boolean));
      equalize(cards.map(card => card.querySelector('.mg-card-reviews')).filter(Boolean));
      for (let i = 0; i < 3; i++) equalize(lists.map(list => list.children[i]).filter(Boolean));
      // Align the benefits even when a card contains an extra badge or price label.
      const offsets = lists.map(list => {
        const card = list.closest('product-card, .mg-product');
        return list.getBoundingClientRect().top - card.getBoundingClientRect().top;
      });
      const top = Math.max(...offsets);
      lists.forEach((list, i) => {
        const margin = parseFloat(getComputedStyle(list).marginTop) || 0;
        list.style.marginTop = (margin + top - offsets[i]) + 'px';
      });
    });
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(align); }
  }
  new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['product-grid-view']});
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  document.fonts.ready.then(schedule);
  schedule();
})();

